import styled from "@emotion/styled";

const RaffleAvatar = styled.div<{ src: string | null }>`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 2px solid #fff;
  background-image: url(${(props) => props.src ?? "/assets/avatar-square.svg"});
  background-size: cover;
  background-position: center;
  z-index: 1;
`;

export default RaffleAvatar;
